import { render } from "./OutboundEvacEmails.vue?vue&type=template&id=28d991ad"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__